import { useRef } from 'react';

import { PieChartTooltipBody } from './components/PieChartTooltipBody.js';
import { useChartActionsMenu } from '../../../core/components/series-action/hooks/useChartActionsMenu.js';
import { ChartTooltip } from '../../../core/components/tooltip/ChartTooltip/ChartTooltip.js';
import {
  useTooltipPinnedStatus,
  useTooltipPosition,
} from '../../hooks/store/selectors.js';
import { useRegisterTooltipHandlerCallbacks } from '../../hooks/useRegisterTooltipCallbacks.js';
import { DEFAULT_TOOLTIP_MARGIN } from '../../types/default.js';

/**
 * Tooltip specific to the Pie and Donut Chart.
 */
export const PieChartTooltip = () => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  const pinned = useTooltipPinnedStatus();

  useRegisterTooltipHandlerCallbacks(tooltipRef);

  const {
    selectedItem: selectedItemId,
    actionsMenuRef,
    updateSelectedItem,
    onLeave,
  } = useChartActionsMenu();

  const mousePosition = useTooltipPosition();

  if (!mousePosition) {
    return null;
  }

  const mousePositionWithOffset = {
    x: mousePosition.x,
    y: mousePosition.y + DEFAULT_TOOLTIP_MARGIN,
  };

  return (
    <ChartTooltip
      ref={tooltipRef}
      pinned={pinned}
      position={mousePositionWithOffset}
      onMouseLeave={onLeave}
      actionSelectionValue={{
        selectedItemId,
        actionsMenuRef,
        updateSelectedItem,
      }}
    >
      <PieChartTooltipBody />
    </ChartTooltip>
  );
};
